<h3 class="text-center text-light bg-secondary border">{{loadStatus}} ({{loads.length}})</h3>
<kendo-grid *ngIf="loadStatus!='Orders' && loadStatus!='RFQ-Quote'"
            [data]="statusGridData"
            [height]="'100%'"
            [sort]="statusGridState.sort"
            [filter]="statusGridState.filter"
            [sortable]="true"
            [pageable]="false"
            [filterable]="true"
            [resizable]="true"
            [rowClass]="rowCallback"
            (cellClick)="loadClick($event)"
            (dataStateChange)="dataStateChange($event)">
    <kendo-grid-column field="quoteOrderLineID" [hidden]="true"></kendo-grid-column>
    <kendo-grid-column field="originCityST" title="Origin"></kendo-grid-column>
    <kendo-grid-column field="destinationCityST" title="Destination"></kendo-grid-column>
    <kendo-grid-column field="orderNumber" title="Order #">
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/order-entry', load.quoteOrderID]">{{load.orderNumber}}-{{load.legNumber}}</a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="firstPickupDate" title="Start" [hidden]="loadStatus!='Available'&&loadStatus!='Planned'">
        <ng-template kendoGridCellTemplate let-load>
            {{load.firstPickupDate == '' ? '' : load.firstPickupDate | date: 'M/dd HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="nextEvent" title="Next Event" [hidden]="loadStatus=='Planned'||loadStatus=='Available'||loadStatus=='Completed'">
        <ng-template kendoGridCellTemplate let-load>
            <span *ngIf="load.nextEvent!=''">
                <i class="fas fa-circle fa-lg" [ngClass]="{'text-danger': load.minutesUntilDue <= 0, 'text-warning': load.minutesUntilDue > 0 && load.minutesUntilDue <= 15, 'text-primary': load.minutesUntilDue > 15 && load.minutesUntilDue <= 30, 'text-success': load.minutesUntilDue > 30}"></i>
                {{load.nextEvent}} {{load.orderEventDate | date: 'M/dd HH:mm'}}
            </span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Tags">
        <ng-template kendoGridCellTemplate let-load>
            <span *ngFor="let tag of getTagTypes(load.tagTypes)">
                <tagtype-tag [tag]="tag"></tagtype-tag>
            </span>
        </ng-template>
    </kendo-grid-column>
</kendo-grid>

<kendo-grid *ngIf="loadStatus=='Orders'"
            [data]="gridData"
            [height]="'100%'"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [sort]="gridState.sort"
            [filter]="gridState.filter"
            [sortable]="true"
            [filterable]="true"
            [pageable]="true"
            [rowClass]="rowCallback"
            (cellClick)="loadClick($event)"
            (dataStateChange)="dataStateChange($event)">
    <kendo-grid-column field="orderNumber" title="Order #">
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/order-entry', load.quoteOrderID]">{{load.orderNumber}}</a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="legNumber" title="Leg"></kendo-grid-column>
    <kendo-grid-column field="customerCode" title="Bill To"></kendo-grid-column>
    <kendo-grid-column field="price" title="Charges">
        <ng-template kendoGridCellTemplate let-load>
            {{load.price == null ? '' : load.price | currency}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="firstPickupDate" title="Start">
        <ng-template kendoGridCellTemplate let-load>
            {{load.firstPickupDate == '' ? '' : load.firstPickupDate | date: 'M/dd HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="deliveryDate" title="Delivery">
        <ng-template kendoGridCellTemplate let-load>
            {{load.deliveryDate == '' ? '' : load.deliveryDate | date: 'M/dd HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="carrierCode" title="Carrier"></kendo-grid-column>
    <kendo-grid-column field="cost" title="Carrier Pay">
        <ng-template kendoGridCellTemplate let-load>
            {{load.cost == null ? '' : load.cost | currency}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="trailerAbbreviation" title="Trailer"></kendo-grid-column>
    <kendo-grid-column field="miles" title="Miles"></kendo-grid-column>
    <kendo-grid-column field="rateIndex" title="Rate Index"></kendo-grid-column>
    <kendo-grid-column field="loadStatus" title="Status"></kendo-grid-column>
    <kendo-grid-column field="erpAssignedTo" title="Tags" [hidden]="true"></kendo-grid-column>
    <kendo-grid-column field="quoteOrderLineType" title="Type" [hidden]="true"></kendo-grid-column>
    <kendo-grid-column field="loadPriorityAbbreviation" title="Priority" [hidden]="true"></kendo-grid-column>
    <kendo-grid-column field="firstPickupDate" title="Start" [hidden]="loadStatus!='Available'&&loadStatus!='Planned'">
        <ng-template kendoGridCellTemplate let-load>
            {{load.firstPickupDate == '' ? '' : load.firstPickupDate | date: 'M/dd HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="shipperCode" title="Shipper"></kendo-grid-column>
    <kendo-grid-column field="originCityST" title="Origin"></kendo-grid-column>
    <kendo-grid-column field="consigneeCode" title="Consignee"></kendo-grid-column>
    <kendo-grid-column field="destinationCityST" title="Destination"></kendo-grid-column>
    <kendo-grid-column field="modeAbbreviation" title="Mode"></kendo-grid-column>
    <kendo-grid-column field="productName" title="Product"></kendo-grid-column>
    <kendo-grid-column field="referenceNumbers" title="Ref #s"></kendo-grid-column>
    <kendo-grid-column field="pieces" title="Pcs"></kendo-grid-column>
    <kendo-grid-column field="weight" title="Wgt"></kendo-grid-column>
</kendo-grid>

<kendo-grid *ngIf="loadStatus=='RFQ-Quote'"
            [data]="rfqQuoteGridData"
            [height]="'100%'"
            [pageSize]="rfqQuoteGridState.take"
            [skip]="rfqQuoteGridState.skip"
            [sort]="rfqQuoteGridState.sort"
            [filter]="rfqQuoteGridState.filter"
            [sortable]="true"
            [filterable]="true"
            [pageable]="true"
            (dataStateChange)="dataStateChange($event)">
    <kendo-grid-column field="orderNumber" title="Order #">
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/order-entry', load.quoteOrderID]">{{load.orderNumber}}</a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="legNumber" title="Leg"></kendo-grid-column>
    <kendo-grid-column field="opportunityNotes" title="Opportunity">
        <ng-template kendoGridCellTemplate let-load>
            <a target="_blank" [routerLink]="['/customer-detail', load.billToCustomerCode, load.opportunityID]" *ngIf="load.opportunityID>0">{{load.opportunityNotes}}</a>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="billToCustomerCode" title="Bill To"></kendo-grid-column>
    <kendo-grid-column field="createdDate" title="Created">
        <ng-template kendoGridCellTemplate let-load>
            {{load.createdDate == '' ? '' : load.createdDate | date: 'M/dd HH:mm'}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="price" title="Charges">
        <ng-template kendoGridCellTemplate let-load>
            {{load.price == null ? '' : load.price | currency}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="finalCost" title="Final Cost">
        <ng-template kendoGridCellTemplate let-load>
            {{load.finalCost == null ? '' : load.finalCost | currency}}
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="quoteOrderLineTypeDesc" title="Type"></kendo-grid-column>
    <kendo-grid-column field="originCityST" title="Origin"></kendo-grid-column>
    <kendo-grid-column field="destinationCityST" title="Destination"></kendo-grid-column>
    <kendo-grid-column field="miles" title="Miles"></kendo-grid-column>
    <kendo-grid-column field="mode" title="Mode"></kendo-grid-column>
    <kendo-grid-column field="trailer" title="Trailer"></kendo-grid-column>
    <kendo-grid-column field="rateIndex" title="Rate Index"></kendo-grid-column>
    <kendo-grid-column field="productName" title="Product"></kendo-grid-column>
</kendo-grid>
